import {EmailBox} from './EmailBox';
export default EmailBox;
